import { PitSelector } from "src/business-components/input/PitSelector/PitSelector";
import { withInlineAutocomplete } from "src/components/input/withInlineAutocomplete/withInlineAutocomplete";
import type { PipelinePitSelectorSelectorProps } from "./PipelinePitSelectorSelector.types";

const InlinePitSelector = withInlineAutocomplete(PitSelector);

export default function PipelinePitSelectorSelector({
  task_id,
  pit,
  pits,
  getOptionDisabled,
  slots,
  onChange,
  ...props
}: PipelinePitSelectorSelectorProps) {
  return (
    <InlinePitSelector
      label={undefined}
      task_id={task_id} // if provided, the "value" will be filtered by this "task_id" and not by "pit" prop
      pit={pit}
      pits={pits}
      getOptionDisabled={getOptionDisabled}
      withReruns
      clearIcon={null}
      forcePopupIcon={false} // hide the "arrow" icon
      slots={slots}
      {...props}
      slotProps={{
        renderOption: {
          onClick: onChange,
        },
        ...props?.slotProps,
      }}
    />
  );
}
